import axios from "axios";

/**
 * Maritime Supply Suite - Dynamic API Config
 */
const isLocal = window.location.hostname === "localhost";

const API_BASE_URL = isLocal 
  ? "http://localhost:5000" 
  : "https://golden-shaina-maritimesupplysuites-ed826a4c.koyeb.app";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  }
});

/* ===== REQUEST INTERCEPTOR ===== */
api.interceptors.request.use(
  (config) => {
    // 1. Attach User Token & Tenant Scope
    const token = localStorage.getItem("token");
    const userSession = JSON.parse(localStorage.getItem("user") || "{}");

    if (token) {
      const cleanToken = token.replace("Bearer ", "").trim();
      config.headers.Authorization = `Bearer ${cleanToken}`;
    }

    if (userSession.adminId) {
      config.headers["x-tenant-id"] = userSession.adminId;
    }

    // 2. SYSTEM HANDSHAKE
    const systemSecret = "maritime_ops_secure_2026"; 
    config.headers["x-admin-secret"] = systemSecret;
    config.headers["x-ops-handshake"] = systemSecret;

    return config;
  },
  (error) => Promise.reject(error)
);

/* ===== AXIOS RESPONSE INTERCEPTOR ===== */
api.interceptors.response.use(
  (response) => response, 
  (error) => {
    const status = error.response?.status;
    const errorMessage = error.response?.data?.msg || error.response?.data?.message || "";

    // 401 Unauthorized always forces logout
    if (status === 401) {
      if (!window.location.pathname.includes("/login")) {
        localStorage.clear(); 
        window.location.href = "/login?expired=true";
      }
    }

    // 403 Forbidden: ONLY logout if it is a permanent account-level termination
    if (status === 403) {
      const lowerMsg = errorMessage.toLowerCase();
      const isAccountRevoked = 
        lowerMsg.includes("revoked") || 
        lowerMsg.includes("disabled by admin") && lowerMsg.includes("account") ||
        lowerMsg.includes("session terminated");

      // Note: "Liquidity Freeze" contains "disabled", so make sure it DOES NOT trigger on liquidity freezes!
      const isLiquidityFreeze = lowerMsg.includes("liquidity freeze");

      if (isAccountRevoked && !isLiquidityFreeze && !window.location.pathname.includes("/login")) {
        localStorage.clear();
        window.location.href = "/login?expired=true";
      }
    }

    return Promise.reject(error);
  }
);

export default api;